let headerHeight;

$(document).ready(function() {
  calculateHeaderHeight();
});

$(window).on('resize', function() {
  calculateHeaderHeight();
});

$(window).on('scroll', function() {
  let scrollPosition = $(this).scrollTop();
  let $header = $('.header');

  if (scrollPosition >= 1) {
    $header.addClass('header--sticky');
  } else {
    $header.removeClass('header--sticky');
  }
});

function calculateHeaderHeight() {
  headerHeight = $('.header').outerHeight();
  $('.header-spacer').height(headerHeight);
}
